import { Action } from '../../common/actions/core/action';

export class OpenYearlyContractedAction implements Action {
  constructor(public onApprove: () => any) {}
}



// WEBPACK FOOTER //
// src/app/buy/yearly-contracted-info/yearly-contracted-dialog.action.ts